import { rowWeightsValidatorFn } from "../baysData/rowWeightsValidator";
import { cloneObject } from "@tedivo/tedivo-pure-helpers";
import { isPlainObject } from "../structure/patterns";
/**
 * Drops the weights that `rowWeightsValidator` reports. An entry left with nothing but
 * its `size` is removed too, and an emptied `rowInfoByLength` with it: such an entry
 * carries no information, and for a 40'+ size it would still make the Bay look as if
 * it held 40s. The input is not modified.
 *
 * Runs before `fixBay40sLocation` in `repairOvd`, so placeholder weights never turn a
 * pair into a split one.
 */
export function fixRowWeights(json) {
    const { findings } = rowWeightsValidatorFn({
        data: { json, lcgVcgTcgAndPairings: undefined, lcgsBy20Bay: undefined },
    }).result;
    if (findings.length === 0)
        return { json, dropped: [], entriesRemoved: 0, changed: false };
    const newJson = cloneObject(json);
    let entriesRemoved = 0;
    const byBayLevel = new Map();
    findings.forEach((f) => {
        var _a;
        const key = `${f.isoBay}-${f.level}`;
        byBayLevel.set(key, [...((_a = byBayLevel.get(key)) !== null && _a !== void 0 ? _a : []), f]);
    });
    newJson.baysData.forEach((entry) => {
        if (!isPlainObject(entry))
            return;
        const list = byBayLevel.get(`${entry["isoBay"]}-${entry["level"]}`);
        if (list === undefined)
            return;
        list.forEach((f) => {
            var _a;
            const dict = f.row === undefined
                ? entry["infoByContLength"]
                : isPlainObject(entry["perRowInfo"]) && isPlainObject(entry["perRowInfo"]["each"])
                    ? (_a = entry["perRowInfo"]["each"][f.row]) === null || _a === void 0 ? void 0 : _a["rowInfoByLength"]
                    : undefined;
            if (!isPlainObject(dict))
                return;
            const e = dict[String(f.size)];
            if (!isPlainObject(e))
                return;
            delete e[f.field];
            const remaining = Object.keys(e).filter((k) => k !== "size");
            if (remaining.length === 0) {
                delete dict[String(f.size)];
                entriesRemoved++;
            }
        });
        // An emptied rowInfoByLength is meaningless
        const each = isPlainObject(entry["perRowInfo"]) ? entry["perRowInfo"]["each"] : undefined;
        if (isPlainObject(each)) {
            Object.values(each).forEach((r) => {
                if (isPlainObject(r) &&
                    isPlainObject(r["rowInfoByLength"]) &&
                    Object.keys(r["rowInfoByLength"]).length === 0)
                    delete r["rowInfoByLength"];
            });
        }
    });
    return { json: newJson, dropped: findings, entriesRemoved, changed: true };
}
